import { render, staticRenderFns } from "./simage.vue?vue&type=template&id=6ccb8979&"
import script from "./simage.vue?vue&type=script&lang=js&"
export * from "./simage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports